<script>
    import dayjs from 'dayjs';
    import { Progress } from '@sveltestrap/sveltestrap';
    import { slide } from 'svelte/transition';

    export let course;
    let showInfo = false;

</script>
<div class='card'>
    <div class='card-body'>
        <div class='row'>
            <div class='col-md-2 col-sm-12'>
                <div class='d-grid mb-3'>
                    <a href='/courses/{ course.id }' class='btn btn-outline-success'>
                        <span class='fas fa-plus-circle'></span> Book
                    </a>
                </div>
            </div>    
            <div class='col-md-9 col-sm-12'>
                <h6 class='mb-2'>
                    <span class='fas fa-registered'></span> { course.title }
                </h6>        

                <div class='mb-2'>
                    <span class='badge bg-secondary rounded shadow-sm me-2'>
                        <span class='fas fa-calendar'></span> { dayjs(course.start).format('HH:mm')}
                    </span>

                    {#if course.multi_day === true}
                        
                        <span class='badge bg-secondary rounded shadow-sm me-2'>
                            <span class='fas fa-calendar-day'></span> { course.num_days } Days
                        </span>                

                    {:else}
                        
                        {#if course.allday === false}

                            <span class='badge bg-secondary rounded shadow-sm'>
                                <span class='fas fa-calendar'></span> { dayjs(course.end).format('HH:mm')}
                            </span>

                        {:else}

                            <span class='badge bg-secondary rounded shadow-sm'>
                                <span class='fas fa-calendar'></span> All day
                            </span>

                        {/if}                

                    {/if}

                </div>

                <div class='clearfix'>        
                    {#if showInfo === false}

                        <button type='button' class='btn btn-outline-secondary float-end btn-sm d-none d-lg-block' on:click={() => showInfo = true}>
                            <span class='fas fa-chevron-down'></span> Course Information
                        </button>
                    
                    {/if}    

                    <div class='mb-2'>
                        <span class='fas fa-map-marker'></span> { course.venue }
                    </div>

                    {#if course.instructors.length > 0}

                        <div class='mb-2'>

                            {#each course.instructors as i}

                                <span class='badge bg-secondary shadow-sm rounded'>
                                    <span class='fas fa-user-shield'></span> { i }
                                </span>

                            {/each}
                        </div>

                    {/if}

                    <div class='mb-2'>

                        <Progress 
                            value={course.percent}
                            color='success'
                            striped                
                        >
                            <span class='fw-bold'>
                                { course.percent }%
                            </span>
                        </Progress>

                    </div>

                    {#if showInfo === false}

                        <div class='d-lg-none text-end mb-2'>
                            <span 
                                class='js-button' 
                                on:click={() => showInfo = true}
                                on:keypress={() => showInfo = true}
                                role='button'
                                tabindex='0'
                            >
                                <span class='fas fa-chevron-down'></span> Course Information
                            </span>
                        </div>

                    {:else}

                        <div class='d-lg-none text-end mb-2'>
                            <span 
                                class='js-button' 
                                on:click={() => showInfo = false}
                                on:keypress={() => showInfo = false}
                                role='button'
                                tabindex='0'
                            >
                                <span class='fas fa-chevron-up'></span> Hide Course Information
                            </span>
                        </div>
                        
                    {/if}
                </div>

            </div>
            <div class='col-md-1 col-sm-12 text-center'>

                <div class='d-none d-lg-block'>
                    <span class='fas fa-users'></span>
                    <br/>
                    <h5 class='m-0'>
                    
                        { course.places_left}<br/>
                        Left

                    </h5>
                </div>
                <div class='d-lg-none'>
                    <h6 class='m-0'>
                        <span class='fas fa-users'></span> { course.places_left} Left
                    </h6>
                </div>
            </div>
        </div>

        {#if showInfo === true}

            <section in:slide out:slide class='mt-3'>
                <div class='card mb-3'>
                    <div class='card-header'>
                        <span class='fas fa-info-circle'></span> Course Information
                    </div>
                    <div class='card-body'>
                        <p class='text-end d-none d-lg-block'>
                            <button type='button' class='btn btn-outline-info btn-sm' on:click={() => showInfo = false}>
                                <span class='fas fa-chevron-up'></span> Hide Course Information
                            </button>
                        </p>

                        <small class='d-lg-none'>
                            {@html course.description}
                        </small>

                        <div class='d-none d-lg-block'>
                            {@html course.description}
                        </div>

                    </div>
                </div>
            </section>

        {/if}
    </div>
</div>